import { createRoot } from 'react-dom/client'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { PRETIREMENT_QUIZ_CALLOUT } from '../lib/constants'

const setCookie = (name, value, days) => {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + date.toUTCString()
  document.cookie = name + '=' + value + ';' + expires + ';path=/'
}

const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

const QuizCallout = ({ data }) => {
  const [state, setState] = useState(false)

  useEffect(() => {
    const cookie = getCookie(PRETIREMENT_QUIZ_CALLOUT)
    if (!cookie) {
      setState(true)
    }
  }, [])

  const handleClose = () => {
    setCookie(PRETIREMENT_QUIZ_CALLOUT, false, 30)
    setState('closing')

    // Set state to false after animation completes
    setTimeout(() => {
      setState(false)
    }, 300)
  }

  return (
    <div
      className={`
      container quiz-callout-animate flex relative flex-col py-8 px-4 gap-1 bg-blue-300 rounded-lg lg:gap-10 lg:py-12 lg:pl-12 lg:pr-24 mx-auto lg:flex-row
      ${state === true ? 'block' : state === 'closing' ? 'closing' : 'hidden'}
    `}
    >
      <button
        className="absolute top-4 right-4 p-4 text-blue-800 rounded-full border border-blue-800 transition-colors duration-150 hover:bg-blue-500 hover:text-white focus-visible:bg-blue-500 focus-visible:text-white focus-visible:outline focus-visible:outline-blue-800 focus-visible:outline-offset-2"
        onClick={handleClose}
        aria-controls="quiz-callout"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="23"
          viewBox="0 0 24 23"
          fill="none"
        >
          <path
            d="M2.37295 0L23.5862 21.2132L22.1719 22.6274L0.95874 1.41421L2.37295 0Z"
            fill="currentColor"
          />
          <path
            d="M22.5858 0L1.37264 21.2132L2.78685 22.6274L24.0001 1.41421L22.5858 0Z"
            fill="currentColor"
          />
        </svg>
        <span className="sr-only">Close</span>
      </button>
      {data.image && (
        <img
          src={data.image.url}
          alt={data.image.alt || ''}
          className="w-full max-w-[275px] h-full mx-auto lg:mx-0"
        />
      )}
      <div className="text-center lg:text-left">
        <h2 className="text-base font-bold tracking-widest text-blue-800 uppercase font-utility">
          {data.heading}
        </h2>
        <div
          className="mt-2 text-gray-500 prose prose-lg text-pretty !max-w-full lg:text-body-lg"
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
        {data.button && (
          <a
            className={`btn mt-4 ${data.button.class}`}
            href={data.button.href}
          >
            {data.button.text}
          </a>
        )}
      </div>
    </div>
  )
}

QuizCallout.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    }),
    heading: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.shape({
      class: PropTypes.string,
      href: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
}

export default QuizCallout

if (document.getElementById('quiz-callout')) {
  const container = document.getElementById('quiz-callout')

  const props = Object.assign({}, container.dataset)
  const root = createRoot(container)

  props.data = JSON.parse(props.props)

  root.render(<QuizCallout {...props} />)
}
